import React from 'react';
import ViewCerti from '../view/ViewCerti';
import { infoMenus } from '../ref/refINFO';
import ViewBase from '../view/ViewBase';

const PageCerti = () => {

    //----------------------------------------------------------------- Working Function Area Start
    //----------------------------------------------------------------- Working Function Area End

    //----------------------------------------------------------------- useEffect Area Start
    //----------------------------------------------------------------- useEffect Area End

    //----------------------------------------------------------------- Header Button Area Start
    //----------------------------------------------------------------- Header Button Area End
    const propDatas = {
        curPath: infoMenus[1].path,
    }

    return (
        <>
            <ViewBase {...propDatas} ViewContainer={ViewCerti}/>
        </>
    );
}

export default PageCerti;